import React from "react";
import PropTypes from "prop-types";
import UserThumb from "shared/components/UserThumb";
import classnames from "classnames";

import UserWrapper from "apps/discovery/containers/user/UserWrapper";
import "./QuestionComment.scss";

const QUESTION_CHAR_LIMIT = 130;
const ANSWER_CHAR_LIMIT = 50;
const EXPLANATION_CHAR_LIMIT = 80;
const BLANK_QUESTION = {
	category: "",
	text: "",
	answer: "",
	explanation: "",
};

const QuestionComment = (props) => {
	const { user, placeholder } = props;

	if (placeholder) {
		return (
			<div className="user-questionComment isPlaceholder">
				<div className="user-questionComment-category" />
				<div className="user-questionComment-user-image" />
			</div>
		);
	}

	// Default fields for question,
	// overwritten with user's data.
	const question = {
		...BLANK_QUESTION,
		...user.question,
	};

	const category = question.category;
	const categoryClasses = classnames({
		"user-questionComment-category": true,
		[`category-${category}`]: true,
	});

	return (
		<UserWrapper className="user-questionComment" {...props}>
			<div className={categoryClasses}>
				<div className="user-questionComment-category-text">
					{category.capitalize()}
				</div>
			</div>

			<div className="user-questionComment-user-image">
				<UserThumb
					{...user}
					size="100x100"
				/>
			</div>

			<div className="user-questionComment-question">
				Q:
				{" "}
				{question.text.length <= QUESTION_CHAR_LIMIT &&
					<span>{question.text}</span>
				}
				{question.text.length > QUESTION_CHAR_LIMIT &&
					<span>{question.text.slice(0, QUESTION_CHAR_LIMIT)}…</span>
				}
			</div>

			<div className="user-questionComment-answer">
				A:
				{" "}
				{question.answer.length <= ANSWER_CHAR_LIMIT &&
					<span>{question.answer}</span>
				}
				{question.answer.length > ANSWER_CHAR_LIMIT &&
					<span>{question.answer.slice(0, ANSWER_CHAR_LIMIT)}…</span>
				}
			</div>

			<div className="user-questionComment-explanation">
				{question.explanation.length <= EXPLANATION_CHAR_LIMIT &&
					<span>“{question.explanation}”</span>
				}
				{question.explanation.length > EXPLANATION_CHAR_LIMIT &&
					<span>“{question.explanation.slice(0, EXPLANATION_CHAR_LIMIT)}…”</span>
				}
			</div>
		</UserWrapper>
	);
};

QuestionComment.propTypes = {
	user: PropTypes.shape({
		question: PropTypes.shape({
			category: PropTypes.string,
			text: PropTypes.string,
			answer: PropTypes.string,
			explanation: PropTypes.string,
		})
	}),
	placeholder: PropTypes.bool,
};

QuestionComment.defaultProps = {
	user: {
		question: BLANK_QUESTION,
	},
	placeholder: false,
};

export default QuestionComment;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/user/QuestionComment.jsx